import { searchRoomsUsingPlacesApi } from '../actions/calendarRoomActions';
import { getStore } from '../store/store';
import { updateRoomsFromPlacesApi } from '../utils/getRooms';
import PlacesFilters from 'owa-calendar-scheduling-service/lib/schema/PlacesFilters';
import { orchestrator } from 'satcheljs';

export default orchestrator(searchRoomsUsingPlacesApi, actionMessage => {
    const roomFilters: PlacesFilters = {
        shouldGetSpaces: getStore().roomFilterState.shouldGetSpaces,
        roomListEmails: actionMessage.roomFilters?.roomLists
            ? actionMessage.roomFilters.roomLists.map(x => x.email)
            : null,
        ...actionMessage.roomFilters,
    };

    updateRoomsFromPlacesApi(roomFilters);
});
